import React, {useState, useEffect } from "react"
import { Expander, ExpanderChevronPosition } from '@amzn/stencil-react-components/expander'
import { Text } from '@amzn/stencil-react-components/text'
import {Hr, Col} from "@amzn/stencil-react-components/layout";


export default function QASections({faq, index, isAllExpanded}){
  const [expanded, setExpanded] = useState(isAllExpanded);
  useEffect(() => {
    setExpanded(() => isAllExpanded)
  }, [isAllExpanded]);
  return (
    <Col dataTestId="qa-sections" gridGap="S300" onClick={() => setExpanded(!expanded)}>
      <Expander
        dataTestId="qa-sections-question"
        isExpanded={expanded}
        titleText={faq.question}
        chevronPosition={ExpanderChevronPosition.Trailing}
        key={`faq-${index}`}
      >
        <Text dataTestId="qa-sections-answer" >{faq.answer}</Text>
      </Expander>
      <Hr/>
    </Col>
  )
};
